module.exports = __webpack_public_path__ + "img/alex_myprofile_grey.9ea028d6.svg";